import { AssetsProps } from "../../../../packages/Header/types";
import { useMemo } from "react";
import CopyTradeIcon from "@/nav-localized/assets/header/copy-trade.svg?react";
import EarnAccountIcon from "@/nav-localized/assets/header/earn-account.svg?react";
import FundingIcon from "@/nav-localized/assets/header/funding.svg?react";
import FuturesAccountIcon from "@/nav-localized/assets/header/futures-account.svg?react";
import HistoryIcon from "@/nav-localized/assets/header/history.svg?react";
import AccountLine from "@/nav-localized/assets/header/account-line.svg?react";
import OrderIcon from "@/nav-localized/assets/header/order.svg?react";
import SpotIcon from "@/nav-localized/assets/header/spot.svg?react";
import AuditsIcon from "@/nav-localized/assets/header/audits.svg?react";

const useAssets = (isTrader: boolean) => {
  const assets: AssetsProps[] = useMemo(
    () => [
      {
        label: "funding",
        link: "assets/funding",
        icon: FundingIcon,
        key: 1
      },
      {
        label: "spotAccount",
        link: "assets/spot",
        icon: SpotIcon,
        key: 2,
        isSupportDemoTrading: true,
        isSupportSubAccount: true
      },
      {
        label: "futuresAccount",
        link: "assets/derivatives",
        icon: FuturesAccountIcon,
        key: 3,
        isSupportDemoTrading: true,
        isSupportSubAccount: true
      },
      {
        label: "trading",
        link: "assets/trading",
        icon: FuturesAccountIcon,
        key: 10,
        isSupportDemoTrading: true,
        isSupportSubAccount: true
      },
      {
        label: "copyTrading",
        link: "assets/copy-trading",
        icon: CopyTradeIcon,
        isSupportSubAccount: isTrader,
        key: 4
      },
      {
        label: "earnAccount",
        link: "assets/earn",
        icon: EarnAccountIcon,
        key: 5
      },
      {
        key: 999,
        type: "line",
        label: "history",
        icon: null,
        link: ""
      },
      {
        label: "accountAnalysis",
        link: "assets/analysis",
        icon: AccountLine,
        key: 6,
        isSupportSubAccount: true
      },
      {
        label: "history",
        link: "assets/history",
        icon: HistoryIcon,
        key: 7,
        isSupportSubAccount: true
      },
      {
        label: "orderCenter",
        link: "assets/orders",
        icon: OrderIcon,
        key: 8,
        isSupportDemoTrading: true,
        isSupportSubAccount: true
      },
      {
        label: "audits",
        link: "assets/audits",
        icon: AuditsIcon,
        key: 9,
        isSupportSubAccount: true
      }
    ],
    []
  );

  return assets;
};

export default useAssets;
